<div class="container-fluid">
  <div class="report-header">
    <div>
      <h1 class="report-title">WIP e Capacidade</h1>
      <p class="report-subtitle">Visão de carga, filas e gargalos por etapa e responsável.</p>
    </div>
  </div>

  <div class="panel report-filters">
    <div class="report-filters__grid">
      <div class="filter-field">
        <label for="filterStart">Período (início)</label>
        <input
          id="filterStart"
          type="date"
          class="form-control"
          [(ngModel)]="filterStart"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterEnd">Período (fim)</label>
        <input
          id="filterEnd"
          type="date"
          class="form-control"
          [(ngModel)]="filterEnd"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterSeguradora">Seguradora</label>
        <select
          id="filterSeguradora"
          class="form-control"
          [(ngModel)]="filterSeguradora"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let seguradora of seguradoras" [value]="seguradora">
            {{ seguradora }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterResponsavel">Responsável atual</label>
        <select
          id="filterResponsavel"
          class="form-control"
          [(ngModel)]="filterResponsavel"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let responsavel of responsaveis" [value]="responsavel">
            {{ responsavel }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterStatus">Status</label>
        <select
          id="filterStatus"
          class="form-control"
          [(ngModel)]="filterStatus"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option value="EM_ANDAMENTO">Em andamento</option>
          <option value="CONCLUIDO">Finalizado</option>
          <option value="ATRASADO">Atrasado</option>
        </select>
      </div>
      <div class="filter-field filter-field--inline">
        <label>
          <input type="checkbox" [(ngModel)]="onlyWip" (change)="applyFilters()" />
          Somente em produção (WIP)
        </label>
      </div>
      <div class="filter-field">
        <label for="filterParado">Parado há (dias)</label>
        <input
          id="filterParado"
          type="number"
          min="0"
          class="form-control"
          [(ngModel)]="paradoDias"
          (change)="applyFilters()"
        />
      </div>
    </div>
  </div>

  <div class="report-kpis">
    <div class="kpi-card">
      <div class="kpi-label">WIP atual</div>
      <div class="kpi-value">{{ wipTotal }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Em atraso</div>
      <div class="kpi-value">{{ wipAtraso }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Parados</div>
      <div class="kpi-value">{{ wipParados }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">No prazo</div>
      <div class="kpi-value">{{ wipNoPrazo }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Entraram no período</div>
      <div class="kpi-value">{{ entradasPeriodo }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Saíram no período</div>
      <div class="kpi-value">{{ saidasPeriodo }}</div>
    </div>
  </div>

  <div class="tabs-pill report-tabs" role="tablist">
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'etapa'"
      (click)="activeTab = 'etapa'"
    >
      Por etapa
    </button>
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'responsavel'"
      (click)="activeTab = 'responsavel'"
    >
      Por responsável
    </button>
    <!-- <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'fila'"
      (click)="activeTab = 'fila'"
    >
      Fila e capacidade
    </button> -->
  </div>

  <div *ngIf="activeTab === 'etapa'">
    <div class="stage-grid">
      <div class="stage-card" *ngFor="let stage of stageSummaries">
        <div class="stage-card__header">
          <div class="stage-title">{{ stage.etapa }}</div>
          <div class="stage-count">{{ stage.wip }}</div>
        </div>
        <div class="stage-chips">
          <span class="chip chip--danger">Atrasados: {{ stage.atrasados }}</span>
          <span class="chip chip--warning">Parados: {{ stage.parados }}</span>
        </div>
        <div class="stage-meta">Idade média na etapa: {{ stage.idadeMedia }} dias</div>
        <div class="stage-mini">
          <div class="stage-mini__title">Casos críticos</div>
          <div class="stage-mini__item" *ngFor="let item of stage.criticos">
            <span>{{ formatOsNumero(item) }}</span>
            <span class="muted">{{ getDiasNaEtapaAtual(item) }}d</span>
          </div>
          <button class="stage-link" type="button" (click)="selectedStage = stage.etapa">
            Ver lista
          </button>
        </div>
      </div>
    </div>

    <div class="panel report-table" *ngIf="selectedStage">
      <h2 class="section-title">Casos da etapa: {{ selectedStage }}</h2>
      <div class="wf-table-card">
        <table class="wf-table">
          <thead>
            <tr>
              <th class="col-number">Número OS</th>
              <th>Veículo</th>
              <th class="col-user">Responsável</th>
              <th class="col-date">Final Prevista</th>
              <th class="col-days">Atraso (dias)</th>
              <th class="col-days">Dias na etapa</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of selectedStageItems">
              <td class="col-number">{{ formatOsNumero(item) }}</td>
              <td>{{ formatVeiculo(item) }}</td>
              <td class="col-user">{{ item.responsavelAtual || '—' }}</td>
              <td class="col-date">
                {{
                  getDataFinalPrevista(item)
                    ? (getDataFinalPrevista(item) | date: 'dd/MM/yyyy')
                    : '—'
                }}
              </td>
              <td class="col-days">{{ getAtrasoDiasAtual(item) }}</td>
              <td class="col-days">{{ getDiasNaEtapaAtual(item) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'responsavel'">
    <div class="person-layout">
      <div class="person-list">
        <button
          class="person-card"
          *ngFor="let person of personSummaries"
          [class.active]="selectedResponsavel === person.responsavel"
          (click)="selectedResponsavel = person.responsavel"
        >
          <div class="person-name">{{ person.responsavel }}</div>
          <div class="person-metrics">
            <span>WIP: {{ person.wip }}</span>
            <span>Atrasados: {{ person.atrasados }}</span>
            <span>Parados: {{ person.parados }}</span>
          </div>
          <div class="person-meta">Etapa mais comum: {{ person.etapaTop }}</div>
        </button>
      </div>
      <div class="person-detail">
        <div class="panel report-table" *ngIf="selectedResponsavel">
          <h2 class="section-title">Casos de {{ selectedResponsavel }}</h2>
          <div class="wf-table-card">
            <table class="wf-table">
              <thead>
                <tr>
                  <th class="col-number">Número OS</th>
                  <th>Veículo</th>
                  <th class="col-stage">Etapa</th>
                  <th class="col-date">Final Prevista</th>
                  <th class="col-days">Atraso (dias)</th>
                  <th class="col-days">Dias na etapa</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of selectedPersonItems">
                  <td class="col-number">{{ formatOsNumero(item) }}</td>
                  <td>{{ formatVeiculo(item) }}</td>
                  <td class="col-stage">{{ getEtapaAtualLabel(item) }}</td>
                  <td class="col-date">
                    {{
                      getDataFinalPrevista(item)
                        ? (getDataFinalPrevista(item) | date: 'dd/MM/yyyy')
                        : '—'
                    }}
                  </td>
                  <td class="col-days">{{ getAtrasoDiasAtual(item) }}</td>
                  <td class="col-days">{{ getDiasNaEtapaAtual(item) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'fila'">
    <div class="capacity-grid">
      <div class="capacity-card">
        <div class="capacity-title">Entradas no período</div>
        <div class="capacity-value">{{ entradasPeriodo }}</div>
        <div class="capacity-list">
          <div class="capacity-item" *ngFor="let item of entradasPorDia">
            <span>{{ formatDateLabel(item.date) }}</span>
            <span>{{ item.count }}</span>
          </div>
        </div>
      </div>
      <div class="capacity-card">
        <div class="capacity-title">Saídas no período</div>
        <div class="capacity-value">{{ saidasPeriodo }}</div>
        <div class="capacity-list">
          <div class="capacity-item" *ngFor="let item of saidasPorDia">
            <span>{{ formatDateLabel(item.date) }}</span>
            <span>{{ item.count }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel capacity-balance">
      <div class="balance-label">Saldo do período</div>
      <div class="balance-value">{{ saldoPeriodo }}</div>
      <div class="balance-note">
        Seu WIP tende a
        {{ saldoPeriodo > 0 ? 'crescer' : saldoPeriodo < 0 ? 'diminuir' : 'manter-se estável' }}.
      </div>
    </div>
  </div>
</div>
